// Spec 078 — páginas da biblioteca de modelos 3D. O estúdio de calibração está DENTRO da cerca do
// 3D (importa three) e por isso entra por lazy: a listagem não paga o motor.
import * as React from "react";
import { Models3dLibrary } from "@/features/models-3d/Models3dPage";
import { SceneSkeleton } from "@/features/lines/scene/SceneSkeleton";

const CalibrationStudio = React.lazy(() =>
  import("@/features/models-3d/CalibrationStudio").then((m) => ({ default: m.CalibrationStudio }))
);

export function Models3dPage(): React.ReactElement {
  return <Models3dLibrary />;
}

export function Model3dCalibrationPage(): React.ReactElement {
  return (
    <React.Suspense
      fallback={
        <div
          className="h-[var(--studio-h)]"
          style={{ "--studio-h": "560px" } as React.CSSProperties}
        >
          <SceneSkeleton label="Carregando estúdio de calibração…" />
        </div>
      }
    >
      <CalibrationStudio />
    </React.Suspense>
  );
}
